// ALTIERO shared helpers: the settings, words, catalogue, size charts and markup every page uses, as window.UI, plus
// UI.define for behaviour as custom elements and the theme editor's block select. chrome.js, loaded next, draws the header,
// footer, bag and panels. Prices, stock and the cart live in store.js; never re-implement pricing here.
// The store's copy: assets/js/ui.js stays as the frozen prototype's. Here UI._chrome carries only what the theme's
// chrome.js reads (Liquid prints the bar, header, footer and logos now).
(function () {
  'use strict';
  var S = window.Store;
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var money = S.money;
  var num = function (n) { return Math.round(n).toLocaleString('en-US'); };
  var reduce = function () { return matchMedia('(prefers-reduced-motion: reduce)').matches; };
  // The second card photo only shows on hover, so phones never download it.
  var HOVER = matchMedia('(hover: hover)').matches;
  // Media are named by their path in the prototype (under assets/), which the build looks for to ship them. In the store
  // they sit flat in the theme's asset folder (img/logo-dark.png -> img-logo-dark.png) at THEME.assetBase, which the layout prints.
  // Without it (the prototype), or for a URL that is already whole, the path stays as it is.
  var BASE = (window.THEME && window.THEME.assetBase) || '';
  var asset = function (path) { return BASE && /^assets\//.test(path) ? BASE + path.slice(7).replace(/\//g, '-') : path; };

  // Contact details and words: Theme settings in the store (THEME.site), else the prototype's.
  var SITE = (window.THEME && window.THEME.site) || {};
  // a section's own words (Complete the look) as <script data-site>: over THEME.site, copy key by key
  $$('script[data-site]').forEach(function (s) {
    try { var o = JSON.parse(s.textContent); Object.keys(o).forEach(function (k) { SITE[k] = k === 'copy' ? Object.assign({}, SITE.copy, o.copy) : o[k]; }); } catch (e) {}
  });
  var DEF = { wa: '201065025304', ig: 'https://www.instagram.com/altiero.co/' };
  var WHATSAPP = String(SITE.whatsapp || '').replace(/\D/g, '') || DEF.wa;
  var INSTAGRAM = SITE.instagram || DEF.ig;
  var at = function (url) { return '@' + url.replace(/[?#].*$/, '').replace(/\/+$/, '').split('/').pop().replace(/^@/, ''); };
  // Theme settings > Shipping > Free delivery when paying by card (the store's free "Pay by Card" shipping rate). Unticked,
  // every line about it gives way to its no-card line, also where Shopify still holds that line as the setting's default.
  var CARD = SITE.cardFree !== false;
  // Theme settings > Discounts > Card payment, percent off (the payment discount app's percent; 0: the site never says it)
  var CARD_PCT = Math.max(0, Math.round(+SITE.cardPercent || 0));
  // Shopper-facing lines the owner edits in Theme settings (Delivery and returns, Cart, Search) or in a section (the
  // Footer, the product page), as THEME.site.copy; a cleared field brings back the line here. The settings' defaults in
  // config/settings_schema.json are these lines: change both together. chrome.js reads it as
  // UI.copy. [pieces], [search] and [product] are filled in where the line shows.
  var COPY_DEFAULTS = {
    "delivery": "Delivered in 1–5 business days",
    "delivery_note": "Free when you pay by card.",
    "card_delivery": "Pay by card at checkout and delivery is free.",
    "cod": "Cash on delivery",
    "cod_note": "Pay in cash when it arrives.",
    "inspect": "Inspect before you pay",
    "inspect_note": "Open it, check it, then pay.",
    "exchanges": "Exchanges within 7 days, returns within 3",
    "exchanges_note": "Wrong size? Swap it.",
    "pay_line": "Cash on delivery. Inspect before you pay.",
    "menu_note": "Cash on delivery across Egypt. Inspect before you pay.",
    "delivery_full": "Orders are processed within 24 hours (Friday and holiday orders the next business day). Delivery usually takes 1–5 business days across Egypt.",
    "returns_full": "Pay cash on delivery, and open your order to inspect it before you pay. Exchanges within 7 days and returns within 3 days (refunds by InstaPay or e-wallet only). Shipping fees apply to exchanges and returns.",
    "footer_line_1": "Luxury redefined.",
    "footer_line_2": "We dress those who move with intention. Who carry themselves with quiet confidence.",
    "footer_base": "Prices in EGP. We deliver across Egypt.",
    "signup_heading": "First word on new pieces, and 5% off your order.",
    "signup_text": "Join the list and get your code straight away.",
    "signup_note": "Your code shows here as soon as you join. Unsubscribe any time.",
    "signup_button": "Join",
    "signup_done": "You’re on the list.",
    "footer_shop": "Shop",
    "footer_help": "Help",
    "footer_talk": "Talk to us",
    "footer_size_guide": "Size guide",
    "footer_copyright": "© 2026 ALTIERO.",
    "bag_empty_title": "Your bag is empty",
    "bag_empty_text": "Start with a jacket, or a whole look.",
    "bag_empty_picks": "Our jackets",
    "bag_looks": "Or start with a whole look",
    "bag_addons": "Complete the outfit",
    "outfit_missing": "Add [pieces] to complete the look.",
    "outfit_done": "Jacket, pants and a knit: the whole look.",
    "free_over": "Free shipping over",
    "ship_unlocked": "Free shipping unlocked",
    "to_free": "to free shipping",
    "pay_card": "Pay by card",
    "pay_cod": "Pay cash on delivery",
    "checkout": "Checkout",
    "search_placeholder": "Jackets, pants, knits or a colour",
    "search_none": "Nothing matches “[search]”. Try jacket, pants, knit or a colour such as navy.",
    "pdp_details": "The details",
    "pdp_size_up": "Between sizes, or want room for a knit underneath? Go one size up.",
    "pdp_reviews": "Reviews",
    "pdp_no_reviews": "No reviews yet.",
    "pdp_no_reviews_text": "Bought this? Your review helps the next person choose a size.",
    "pdp_seen_text": "Short clips of the [product], filmed around Cairo by customers and models.",
    "nav_shop_all": "Shop all",
    "nav_about": "About",
    "nav_returns": "Returns & exchanges",
    "menu_title": "Menu",
    "signup_label": "Email",
    "signup_placeholder": "name@example.com",
    "signup_error": "Enter an email address, like name@example.com.",
    "signup_code": "Your code [code] takes [percent]% off your order, and we add it at checkout for you.",
    "cart_title": "Your bag",
    "cart_line": "[colour], size [size]",
    "cart_each": "[price] each",
    "cart_remove": "Remove",
    "cart_subtotal": "Subtotal",
    "cart_shipping": "Shipping",
    "cart_shipping_free": "Free",
    "cart_shipping_later": "Calculated at checkout",
    "cart_total": "Total",
    "cart_card_extra": "Extra [percent]% off",
    "card_sheet_title": "[percent]% off when you pay by card",
    "card_sheet_text": "In your bag, tap Pay by card and [percent]% comes off at checkout. Prefer cash? Cash on delivery is still there.",
    "card_sheet_bag": "Open my bag",
    "cart_code": "Your code [code] takes [percent]% off at checkout.",
    "cart_add_in": "Add in",
    "bag_shop_all": "Shop everything",
    "slot_jackets": "Jacket",
    "slot_pants": "Pants",
    "slot_knitwear": "Knit",
    "noun_jackets": "a jacket",
    "noun_pants": "pants",
    "noun_knitwear": "a knit",
    "look_sheet_title": "Add the look",
    "look_sheet_intro": "Choose a size for each piece.",
    "look_add": "Add the look",
    "look_add_one": "Add to bag",
    "ships_free": "Ships free.",
    "toast_sold_out": "That size has just sold out. Pick another size.",
    "toast_look_sold_out": "One of these sizes has just sold out. Pick another size and try again.",
    "toast_bag_updated": "A piece in your bag just sold out or is low on stock, so your bag has been updated.",
    "card_add": "Add",
    "card_faux": "faux leather",
    "from_price": "from [price]",
    "stock_sold_out": "Sold out",
    "stock_only": "Only [size] left",
    "stock_sold_out_in": "Sold out in [sizes]"
  };
  var NO_CARD = { "delivery_note": "Orders are processed within 24 hours." };   // card offer off
  // card percent on: with free card delivery, and without it (then the delivery note keeps its no-card line)
  var PCT_CARD = CARD ? { "delivery_note": "Free, and 5% off, when you pay by card.", "card_delivery": "Pay by card at checkout: 5% off and free delivery." }
    : { "card_delivery": "Pay by card at checkout: 5% off." };
  var COPY = {};
  Object.keys(COPY_DEFAULTS).forEach(function (k) {
    COPY[k] = String((SITE.copy && SITE.copy[k]) || '').trim() || COPY_DEFAULTS[k];
    if (!CARD && k in NO_CARD && COPY[k] === COPY_DEFAULTS[k]) COPY[k] = NO_CARD[k];
    if (CARD_PCT && k in PCT_CARD) COPY[k] = (COPY[k] === COPY_DEFAULTS[k] ? PCT_CARD[k] : COPY[k]).replace(/\d+\s*%/, CARD_PCT + '%');
  });
  if (!CARD && !CARD_PCT) COPY.card_delivery = '';   // the bag's card line goes, whatever it says
  // A page's own words, editable in that page's section in Customize: UI.words('<section file>', { "key": ["Label in the
  // editor", "Default"], ... }) returns { key: the owner's text, else the default }. The section has a setting per key
  // and prints them as <script data-site> (product-look). [bracketed] words are filled in by the caller.
  function words(section, defs) {
    var o = {};
    Object.keys(defs).forEach(function (k) { o[k] = String((SITE.copy && SITE.copy[k]) || '').trim() || defs[k][1]; });
    return o;
  }

  // ---------- icons (24px grid, stroked) ----------
  var ICONS = {
    search: '<circle cx="10.5" cy="10.5" r="6.5"/><path d="m15.5 15.5 5 5"/>',
    bag: '<path d="M5.5 8.5h13l-1 12h-11z"/><path d="M9 8.5V7a3 3 0 0 1 6 0v1.5"/>',
    menu: '<path d="M4 7.5h16M4 12h16M4 16.5h16"/>',
    close: '<path d="M6 6l12 12M18 6 6 18"/>',
    plus: '<path d="M12 5v14M5 12h14"/>',
    minus: '<path d="M5 12h14"/>',
    check: '<path d="m5 12.5 4.2 4L19 7"/>',
    truck: '<path d="M2.5 6.5h11.5v10H2.5z"/><path d="M14 10h4.2l3.3 3.4v3.1H14"/><circle cx="6.5" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/>',
    cash: '<rect x="2.5" y="6.5" width="19" height="11" rx="1"/><circle cx="12" cy="12" r="2.6"/><path d="M6 9.5v5M18 9.5v5"/>',
    card: '<rect x="2.5" y="5.5" width="19" height="13" rx="2"/><path d="M2.5 9.5h19M6 15h4"/>',
    eye: '<path d="M2.5 12S6 6 12 6s9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6z"/><circle cx="12" cy="12" r="2.6"/>',
    calendar: '<rect x="3.5" y="5.5" width="17" height="15" rx="1"/><path d="M3.5 10h17M8 3.5v4M16 3.5v4"/>',
    exchange: '<path d="M4 9h14l-3.5-3.5M20 15H6l3.5 3.5"/>',
    whatsapp: '<path d="M20 11.6a8 8 0 0 1-11.9 7L4 19.8l1.3-3.9A8 8 0 1 1 20 11.6z"/><path d="M9 8.6c0 3.2 2.6 6.2 6 6.4l1-1.6-2-1-1 .9c-1-.4-2-1.4-2.4-2.4l.9-1-1-2z"/>',
    mail: '<rect x="3" y="5.5" width="18" height="13" rx="1"/><path d="m3.5 6.5 8.5 7 8.5-7"/>',
    instagram: '<rect x="3.5" y="3.5" width="17" height="17" rx="4.5"/><circle cx="12" cy="12" r="4"/><path d="M17.2 6.8h.01"/>',
    tiktok: '<path d="M13.5 3.5v11.3a3.7 3.7 0 1 1-3.7-3.7"/><path d="M13.5 3.5c.4 2.5 2.4 4.4 5 4.6"/>',
    ruler: '<path d="M3.5 15.5 15.5 3.5l5 5-12 12z"/><path d="m7 12 2 2M10 9l2 2M13 6l2 2"/>',
    'chevron-left': '<path d="m14.5 5.5-6.5 6.5 6.5 6.5"/>',
    'chevron-right': '<path d="m9.5 5.5 6.5 6.5-6.5 6.5"/>'
  };
  function icon(name, cls) { return '<svg class="i' + (cls ? ' ' + cls : '') + '" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + (ICONS[name] || '') + '</svg>'; }

  // ---------- catalogue helpers ----------
  var NAMES = SITE.catNames || {};   // Theme settings > Prices and categories: Winter'26, Tailored'26, Summer'26 in place of the plain word
  var named = function (id, plain) { return NAMES[id] || plain; };
  var CATS = [
    { id: 'jackets', label: named('jackets', 'Jackets'), plain: 'Jackets', noun: COPY.noun_jackets, slot: COPY.slot_jackets },
    { id: 'pants', label: named('pants', 'Pants'), plain: 'Pants', noun: COPY.noun_pants, slot: COPY.slot_pants },
    { id: 'knitwear', label: named('knitwear', 'Knitwear'), plain: 'Knitwear', noun: COPY.noun_knitwear, slot: COPY.slot_knitwear }
  ];
  var cat = function (id) { return CATS.filter(function (c) { return c.id === id; })[0]; };
  // Shop categories: the outfit three, then any other the products name (a store product of type Shirts), in catalogue order.
  // ponytail: each one is a header link too; past four or five extra types the desktop nav needs a "More" menu.
  var SHOP_CATS = CATS.concat(S.products.reduce(function (a, p) {
    if (!cat(p.category) && p.category !== 'other' && !a.some(function (c) { return c.id === p.category; }))
      a.push({ id: p.category, label: p.catLabel || p.category.charAt(0).toUpperCase() + p.category.slice(1).replace(/-/g, ' ') });
    return a;
  }, []));
  var get = function (p) { return typeof p === 'string' ? S.byHandle(p) : p; };
  // Links work in the static prototype and in the Shopify theme (which sets window.THEME).
  var SHOPIFY = !!window.THEME;
  var productUrl = function (h) { return (SHOPIFY ? '/products/' : 'product.html?h=') + encodeURIComponent(h); };
  // ponytail: the store has no jackets/pants/knitwear collections, so categories ride on /collections/all?c=; real collections would give cleaner URLs.
  var shopUrl = function (c) { c = c || 'all'; return SHOPIFY ? '/collections/all' + (c === 'all' ? '' : '?c=' + c) : 'shop.html?c=' + c; };
  var aboutUrl = SHOPIFY ? '/pages/about' : 'about.html', homeUrl = SHOPIFY ? '/' : 'index.html';
  var fromPath = function (re) { var m = re.exec(location.pathname); return m ? decodeURIComponent(m[1]) : null; };
  var pageHandle = function () { return new URLSearchParams(location.search).get('h') || fromPath(/\/products\/([^/]+)/); };
  var pageCat = function () { return new URLSearchParams(location.search).get('c') || fromPath(/\/collections\/([^/]+)/) || 'all'; };
  var inStock = function (p) { return get(p).sizes.filter(function (z) { return z.available; }).map(function (z) { return z.size; }); };
  // A chart is a photo marked by THEME.merge (alt text "Size chart", or square on one of the original eleven); in the
  // prototype every square image is one.
  var isChart = function (im) { return 'chart' in im ? im.chart : im.w === im.h; };
  // a piece shot only on square photos (a new store product) shows them all and has no chart
  var photos = function (p) { var ims = get(p).images, ph = ims.filter(function (im) { return !isChart(im); }); return ph.length ? ph : ims; };
  var chart = function (p) { return photos(p) === get(p).images ? null : get(p).images.filter(isChart)[0] || null; };
  // Jackets are shot on the grey studio wall; pants, knits and the cropped jacket are flat-lay cut-outs, shown on white.
  var ground = function (p) { p = get(p); return p.category === 'jackets' && p.family !== 'cropped-wool-jacket' ? 'studio' : 'black'; };
  // the lowest in-stock price in a category; null when nothing is in stock (callers then print no price)
  var fromPrice = function (c) { var ps = S.inCategory(c).filter(function (p) { return inStock(p).length; }).map(function (p) { return p.price; }); return ps.length ? Math.min.apply(null, ps) : null; };
  var swatchSrc = function (p) { return asset('assets/img/swatches/cloth-' + get(p).handle + '.webp'); };

  // The three ready outfits from SPEC (in-stock pieces only). `pictured`, when set, is a piece the still shows in place of
  // the one in the look: the maroon still shows the Black polo, not the Ecru. Show that still only with a note saying so
  // (or with the pictured piece swapped in), so what is added matches what was seen.
  var LOOKS = [
    { id: 'noir', name: 'The Noir look', pieces: 'Faux-leather jacket in Noir, navy pants, black knit polo',
      handles: ['altieros-matte-black-leather-jacket', 'relaxed-tailor-pants-navy', 'textured-knit-polo-black'], still: asset('assets/img/campaign/look-noir-kiosk.webp') },
    { id: 'grey', name: 'The Grey look', pieces: 'Grey wool-blend jacket, graphite pants, ecru knit polo',
      handles: ['altieros-grey-wool-blend-jacket', 'relaxed-tailor-pants-graphite', 'textured-knit-polo-ecru'], still: asset('assets/img/campaign/look-grey-seated.webp') },
    { id: 'maroon', name: 'The Deep Maroon look', pieces: 'Faux-leather jacket in Deep Maroon, navy pants, ecru knit polo',
      handles: ['altieros-brownish-burgundy-leather-jacket', 'relaxed-tailor-pants-navy', 'textured-knit-polo-ecru'],
      still: asset('assets/img/campaign/look-maroon-evening.webp'), pictured: 'textured-knit-polo-black' }
  ].map(function (L, n) {
    // Theme settings > Cart: each look's name and jacket (SITE.looks); the jacket's Frequently bought with
    // (custom.frequently_bought_with) picks the pants and the knit when it names one. `asShot` stays true while the pieces
    // are still the ones the campaign photo shows (shop.js shows that photo only then)
    var set = (SITE.looks || [])[n] || {}, hs = L.handles.slice();
    if (String(set.name || '').trim()) L.name = set.name;
    if (set.handle && S.byHandle(set.handle)) hs[0] = set.handle;
    var own = ((S.byHandle(hs[0]) || {}).boughtWith || []).map(S.byHandle).filter(Boolean);
    hs = hs.map(function (h, i) { var q = i && own.filter(function (q) { return q.category === ['', 'pants', 'knitwear'][i]; })[0]; return q ? q.handle : h; });
    L.asShot = hs.join() === L.handles.join();
    if (!L.asShot) { L.handles = hs; L.pieces = hs.filter(S.byHandle).map(function (h) { var q = S.byHandle(h); return q.name + ' in ' + q.colour; }).join(', '); }
    return L;
  }).filter(function (L) { return L.handles.every(S.byHandle); });   // in the theme, a piece archived in the store drops its look

  // Customer clips and the piece each one shows (SPEC map). Clip 06 is never used.
  var CLIPS = [
    { n: 1, handle: null, alt: 'An ALTIERO bag held up to the camera and opened' },
    { n: 2, handle: 'blue-knitted-tee', alt: 'A man in the blue crewneck and white trousers walking past a villa' },
    { n: 3, handle: 'textured-knit-polo-ecru', alt: 'Close-up of the ecru knit polo over dark pants' },
    { n: 4, handle: 'blue-knitted-tee', alt: 'A man in the blue crewneck and white trousers at a café' },
    { n: 5, handle: 'textured-knit-polo-black', alt: 'A man in the black knit polo and white trousers at a mall' },
    { n: 7, handle: 'altieros-ecru-wool-blend-jacket-copy', alt: 'A man in the taupe cropped jacket on a Cairo street at night' },
    { n: 8, handle: 'relaxed-tailor-pants-graphite', alt: 'Graphite tailored trousers worn with a black knit' },
    { n: 9, handle: 'textured-knit-polo-black', alt: 'A man in the black knit polo between tall pillars' },
    { n: 10, handle: 'textured-knit-polo-ecru', alt: 'A man in the ecru knit walking' },
    { n: 11, handle: 'relaxed-tailor-pants-graphite', alt: 'A man in a black tee and graphite tailored pants at a café table' },
    // the jacket in clip 12 isn't ours, only the pants are (Hady, 2026-10-31)
    { n: 12, handle: 'relaxed-tailor-pants-graphite', alt: 'A man in a white tee and graphite tailored pants, in a living room' }
  ].filter(function (c) { return !c.handle || S.byHandle(c.handle); });
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var clipPoster = function (n) { return asset('assets/video/clip-' + pad(n) + '.jpg'); };
  var clipSrc = function (n) { return asset('assets/video/clip-' + pad(n) + '.mp4'); };
  var clipsFor = function (h) { return CLIPS.filter(function (c) { return c.handle === h; }); };

  // ---------- size charts ----------
  // In cm, the brand's official charts (notes/hady-2026-10-30): the size first, the weight range last (the size finder reads
  // it). Theme settings > Size charts replaces each, as text: one row per line, cells split by |, the headings first.
  // build-theme.py reads this object for those settings' defaults: keep it plain JSON. Leather and wool-blend jackets share one.
  var CHART_DEFAULTS = {
    "jackets": { "cols": ["Size", "Length", "Width", "Weight"],
      "rows": [["S", "62", "58", "55–65 kg"], ["M", "64", "60", "65–75 kg"], ["L", "66", "62", "75–85 kg"], ["XL", "68", "64", "85–95 kg"]],
      "note": "Size in centimetres." },
    "pants": { "cols": ["Size", "Length", "Waist", "Thigh", "Weight"],
      "rows": [["S (32)", "110", "40", "31", "55–65 kg"], ["M (34)", "110", "42", "31", "65–75 kg"], ["L (36)", "110", "44", "33", "75–85 kg"], ["XL (38)", "110", "46", "33", "85–95 kg"]],
      "note": "Size in centimetres." },
    "knit_polo": { "cols": ["Size", "Length", "Width", "Sleeve length", "Weight"],
      "rows": [["S (M on tag)", "64", "54", "20", "55–70 kg"], ["M (L on tag)", "66", "56", "20", "70–80 kg"], ["L (XL on tag)", "68", "58", "22", "80–90 kg"]],
      "note": "Size in centimetres. Muscle fit. All sizes are written one size bigger on the neck tag: size S is M on the neck tag." },
    "knit_crewneck": { "cols": ["Size", "Length", "Width", "Sleeve length", "Weight"],
      "rows": [["M", "66", "58", "22", "60–75 kg"], ["L", "68", "60", "23", "75–85 kg"], ["XL", "70", "62", "24", "85–95 kg"]],
      "note": "Size in centimetres. Measurements are of the garment, not the body. When in doubt, size up." }
  };
  // the owner's chart text, else ours; a chart whose rows don't all have the headings' number of cells keeps ours
  var CHART = {};
  Object.keys(CHART_DEFAULTS).forEach(function (k) {
    var own = SITE.charts || {}, lines = String(own[k] || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean)
      .map(function (l) { return l.split('|').map(function (c) { return c.trim(); }); });
    var ok = lines.length > 1 && lines.every(function (r) { return r.length === lines[0].length && r.length > 1; });
    CHART[k] = ok ? { cols: lines[0], rows: lines.slice(1), note: String(own[k + '_note'] || '').trim() || CHART_DEFAULTS[k].note }
      : { cols: CHART_DEFAULTS[k].cols, rows: CHART_DEFAULTS[k].rows, note: String(own[k + '_note'] || '').trim() || CHART_DEFAULTS[k].note };
  });
  // a product's chart by its family (products.js / the Family field); the cropped jacket has none yet
  var CHARTS = { 'leather-jacket': CHART.jackets, 'wool-jacket': CHART.jackets, 'tailored-pants': CHART.pants,
    'knit-polo': CHART.knit_polo, 'knit-crewneck': CHART.knit_crewneck };
  // a size's top weight in kg from its row's last cell ("55–65 kg" -> 65), for Store.sizeForWeight
  var topKg = function (row) { var n = String(row[row.length - 1]).match(/\d+(?:\.\d+)?/g); return n ? +n[n.length - 1] : NaN; };

  // ---------- the shopper's size ----------
  var SIZE_KEY = 'altiero-size';
  function lastSize(set) {
    try { if (set) localStorage.setItem(SIZE_KEY, set); return localStorage.getItem(SIZE_KEY); } catch (e) { return set || null; }
  }
  // The size to preselect: `want` (or the shopper's last size) if in stock, else the nearest in-stock size, ties going up
  // (an XL shopper gets the L polo, not the S). No size known yet: the first in stock. Null when sold out.
  var ORDER = ['S', 'M', 'L', 'XL'];
  function defaultSize(p, want) {
    var ok = inStock(p), i = ORDER.indexOf(want || lastSize());
    if (i < 0) return ok[0] || null;
    var gap = function (z) { return Math.abs(ORDER.indexOf(z) - i); };
    return ok.slice().sort(function (a, b) { return gap(a) - gap(b) || ORDER.indexOf(b) - ORDER.indexOf(a); })[0] || null;
  }

  // ---------- markup helpers ----------
  // Store photos come from Shopify's CDN, which resizes on request (…&width=N): phones get a copy sized to the slot.
  var CDN_WIDTHS = [360, 540, 720, 1080, 1400];
  function srcset(im) {
    // prototype only: local photos have a 540px copy beside them (Shopify resizes its own)
    if (!/[?&]width=\d+/.test(im.src)) return /^assets\/img\/products\/.+\.webp$/.test(im.src) && im.w > 540 ? im.src.replace(/\.webp$/, '-540.webp') + ' 540w, ' + im.src + ' ' + im.w + 'w' : '';
    return CDN_WIDTHS.filter(function (w) { return w <= im.w; })
      .map(function (w) { return im.src.replace(/([?&]width=)\d+/, '$1' + w) + ' ' + w + 'w'; }).join(', ');
  }
  // o.sizes: the slot's width for the browser to pick from srcset (default: a product card).
  function img(im, o) {
    o = o || {};
    var set = srcset(im);
    return '<img' + (o.cls ? ' class="' + o.cls + '"' : '') + ' src="' + esc(im.src) + '"' +
      (set ? ' srcset="' + esc(set) + '" sizes="' + (o.sizes || '(max-width: 860px) 50vw, 25vw') + '"' : '') +
      ' alt="' + esc(o.alt || '') + '" width="' + im.w + '" height="' + im.h + '"' +
      (o.eager ? ' fetchpriority="high"' : ' loading="lazy"') + ' decoding="async">';
  }
  function thumb(p, o) {
    p = get(p); o = o || {};
    var tag = o.href ? 'a' : 'span';
    return '<' + tag + ' class="thumb" data-ground="' + ground(p) + '"' + (o.href ? ' href="' + o.href + '" tabindex="-1" aria-hidden="true"' : '') + '>' + img(photos(p)[0], { sizes: '96px' }) + '</' + tag + '>';
  }
  function swatch(p) {
    p = get(p);
    // no cloth photo (a new store product, cloth: false from THEME.merge): the chip keeps its flat swatch colour, with no 404
    return '<span class="swatch-chip" style="--sw:' + esc(p.swatch) + '">' + (p.cloth === false ? '' : '<img src="' + swatchSrc(p) + '" alt="" width="96" height="96" loading="lazy" onerror="this.remove()">') + '</span>';
  }
  // The family's colours as links; the current one is marked. o.labels shows names, o.small for cards.
  function swatches(p, o) {
    p = get(p); o = o || {};
    return '<ul class="swatches' + (o.small ? ' swatches--sm' : '') + '" aria-label="Colours">' + S.siblings(p).map(function (q) {
      return '<li><a class="swatch" href="' + productUrl(q.handle) + '"' + (q.handle === p.handle ? ' aria-current="true"' : '') +
        (o.labels ? '>' : ' aria-label="' + esc(q.colour) + '" title="' + esc(q.colour) + '">') + swatch(q) + (o.labels ? esc(q.colour) : '') + '</a></li>';
    }).join('') + '</ul>';
  }
  // Size buttons. Default: pickers with aria-pressed (o.selected, o.name -> data-pick). o.quick: each button adds to the bag.
  // o.sold: sold-out sizes stay pickable (data-sold), for a back-in-stock app; otherwise they are disabled.
  function sizeChips(p, o) {
    p = get(p); o = o || {};
    var cls = 'size' + (o.small ? ' size--sm' : '');
    return p.sizes.map(function (z) {
      if (!z.available && !o.sold) return '<button class="' + cls + '" type="button" data-size="' + z.size + '" disabled aria-label="' + z.size + ', sold out">' + z.size + '</button>';
      if (o.quick) return '<button class="' + cls + '" type="button" data-quick="' + p.handle + '" data-size="' + z.size + '" data-k="q-' + p.handle + '-' + z.size + '" aria-label="Add ' + esc(p.name) + ' - ' + esc(p.colour) + ', in ' + z.size + '">' + z.size + '</button>';
      return '<button class="' + cls + '" type="button" data-size="' + z.size + '"' + (o.name ? ' data-pick="' + o.name + '"' : '') + (z.available ? '' : ' data-sold aria-label="' + z.size + ', sold out"') + ' aria-pressed="' + (z.size === o.selected) + '">' + z.size + '</button>';
    }).join('');
  }
  // Stars from the store's reviews app (THEME.merge: p.rating, set only with at least one review). Nothing without reviews.
  function stars(p) {
    var r = get(p).rating; if (!r || !(r.value > 0) || !(r.count > 0)) return '';
    var max = +r.max || 5, v = (+r.value).toFixed(1);
    return '<p class="rating"><span class="rating-stars" style="--r:' + Math.min(1, r.value / max).toFixed(3) + '" aria-hidden="true"></span>' +
      '<span aria-hidden="true">' + v + ' (' + r.count + ')</span><span class="vh">' + v + ' out of ' + max + ', ' + r.count + (r.count === 1 ? ' review' : ' reviews') + '</span></p>';
  }
  // Product card. o: { level: 3, eager: false, quick: true, swatches: true, hover: true, cls: '' }
  // the original price crossed out, then the price (Shopify's Compare at price, when higher and the Theme settings switch is on)
  function priceHTML(p) {
    var was = SITE.showCompare !== false && p.compare > p.price;
    return (was ? '<s class="compare-at-price"><span class="vh">Was </span>' + money(p.compare) + '</s> ' : '') + '<span class="price">' + money(p.price) + '</span>';
  }
  function productCard(p, o) {
    p = get(p); o = o || {};
    var ph = photos(p), alt = o.hover !== false && HOVER && ph[1], note = S.stockNote(p), name = esc(p.name) + ' - ' + esc(p.colour), h = 'h' + (o.level || 3);
    var quick = o.quick !== false && inStock(p).length;
    return '<article class="pcard' + (o.cls ? ' ' + o.cls : '') + '" data-handle="' + p.handle + '">' +
      '<div class="pcard-figure"><a class="pcard-media" href="' + productUrl(p.handle) + '" data-ground="' + ground(p) + '" tabindex="-1" aria-hidden="true">' +
        img(ph[0], { eager: o.eager }) + (alt ? img(alt, { cls: 'pcard-alt' }) : '') + '</a>' +
        (p.badge ? '<span class="pcard-badge">' + esc(p.badge) + '</span>' : '') +
        (quick ? '<div class="pcard-quick"><div class="pcard-sizes" role="group" aria-label="Add ' + name + ' to your bag"><span class="lbl" aria-hidden="true">' + esc(COPY.card_add) + '</span>' + sizeChips(p, { quick: true }) + '</div>' +
          '<button class="pcard-plus" type="button" aria-expanded="false" aria-label="Quick add: ' + name + '">' + icon('plus') + '</button></div>' : '') +
      '</div><div class="pcard-body"><' + h + ' class="pcard-name"><a href="' + productUrl(p.handle) + '">' + esc(p.name) + '</a></' + h + '>' +
      '<p class="pcard-colour">' + esc(p.colour) + (p.faux ? ', ' + esc(COPY.card_faux) : '') + '</p>' + stars(p) +
      (o.swatches !== false && S.siblings(p).length > 1 ? swatches(p, { small: true }) : '') +
      '<p class="pcard-foot">' + priceHTML(p) + (note ? '<span class="stock">' + note + '</span>' : '') + '</p></div></article>';
  }
  var whatsapp = function (text) { return 'https://wa.me/' + WHATSAPP + (text ? '?text=' + encodeURIComponent(text) : ''); };

  // ---------- behaviour as custom elements ----------
  // UI.define('size-picker', { connect: function (signal) {...}, select: function (block) {...} }). connect runs each time
  // the element joins the page, so it starts from its own children and data-*; `signal` ends when it leaves (pass it to
  // addEventListener, or listen for its 'abort' to stop a timer). A section the theme editor redraws starts afresh, with no
  // doubled listeners and no reload. The other members become the element's methods. A custom element is inline until
  // styled: define makes it a block with no weight, so any rule in the page's CSS wins (put display there too, for the
  // first paint before this file runs).
  var blocks = document.head.appendChild(document.createElement('style'));
  function define(name, methods) {
    if (customElements.get(name)) return;
    blocks.textContent += ':where(' + name + '){display:block}';
    var El = class extends HTMLElement {
      connectedCallback() { this.ac = new AbortController(); if (this.connect) this.connect(this.ac.signal); }
      disconnectedCallback() { if (this.ac) this.ac.abort(); }
    };
    Object.assign(El.prototype, methods);
    customElements.define(name, El);
  }
  // Theme editor: picking a block in the sidebar calls select(block) on the nearest custom element around it that has one
  // (the Cover holds that look, a strip scrolls to that clip, a row opens); leaving it calls deselect(block).
  ['select', 'deselect'].forEach(function (k) {
    document.addEventListener('shopify:block:' + k, function (e) {
      for (var el = e.target; el && el.localName; el = el.parentElement)
        if (el.localName.indexOf('-') > 0 && typeof el[k] === 'function') { el[k](e.target); return; }
    });
  });
  // <scroll-rail id="newRail">: a sideways strip (its first child holds the items). Buttons with data-rail="newRail" and
  // data-step="1" or "-1", anywhere on the page, move it by most of its width; a block picked in the editor scrolls into
  // view, moving the strip, never the page.
  define('scroll-rail', {
    connect: function (signal) {
      var rail = this;
      document.addEventListener('click', function (e) {
        var b = e.target.closest('[data-rail]');
        if (b && rail.id && b.dataset.rail === rail.id) rail.scrollBy({ left: +b.dataset.step * rail.clientWidth * .8, behavior: reduce() ? 'auto' : 'smooth' });
      }, { signal: signal });
    },
    select: function (block) {
      var r = this.getBoundingClientRect(), b = block.getBoundingClientRect(), list = this.firstElementChild;
      if (b.left < r.left || b.right > r.right)
        this.scrollTo({ left: this.scrollLeft + b.left - r.left - (list ? parseFloat(getComputedStyle(list).paddingLeft) || 0 : 0), behavior: reduce() ? 'auto' : 'smooth' });
    }
  });

  window.UI = {
    // formatting
    money: money, num: num, esc: esc, icon: icon, copy: COPY, words: words, sizeCharts: CHART, familyCharts: CHARTS, topKg: topKg,
    // data
    CATS: CATS, SHOP_CATS: SHOP_CATS, LOOKS: LOOKS, CLIPS: CLIPS, clipsFor: clipsFor, clipPoster: clipPoster, clipSrc: clipSrc,
    productUrl: productUrl, shopUrl: shopUrl, aboutUrl: aboutUrl, homeUrl: homeUrl, pageHandle: pageHandle, pageCat: pageCat, whatsapp: whatsapp, instagram: INSTAGRAM, instagramAt: at(INSTAGRAM),
    inStock: inStock, ground: ground, photos: photos, chart: chart, fromPrice: fromPrice, lastSize: lastSize, defaultSize: defaultSize,
    // markup
    img: img, thumb: thumb, swatch: swatch, swatchSrc: swatchSrc, swatches: swatches, sizeChips: sizeChips, priceHTML: priceHTML, productCard: productCard, stars: stars,
    // behaviour (add, openCart, openLook, openSearch, openPanel, closePanel, toast, announce and markNav come with chrome.js)
    define: define, asset: asset,
    // for chrome.js only: the settings and helpers it shares with this file
    _chrome: { $: $, $$: $$, reduce: reduce, SITE: SITE, CARD_PCT: CARD_PCT, cat: cat, get: get, SHOPIFY: SHOPIFY }
  };
})();
